export interface MediaAuthor {
    Name: string;
    Title: string;
    Url: string;
    Image: string;
    IsVanEckEmployee: boolean;
}

export enum RelatedMediaType {
    Blog = 1,
    Video = 2,
    Webinar = 3,
    Podcast = 4
}

export enum TopicType {
    Default = 0,
    Fund = 1,
}

interface TopicalTags {
    LinkText: string;
    LinkUrl: {
        Uri: string;
        OriginalString: string;
    };
    TopicType: TopicType;
}

export interface MediaPreview {
    Id: number;
    Type: RelatedMediaType;
    TypeName: string;
    PublishDate?: Date;
    FormattedPublishDate: string;
    Title: string;
    MediaLink: string;
    Image: string;
    Category: string;
    CategoryUrl: string;
    Time: string;
    FormattedTime: string;
    SmallImage: string;
    RecommendedImage: string;
    CategoryPostImage: string;
    Description: string;
    DescriptionString: string;
    Details: string;
    Info: string;
    PostSmallImage: string;
    Authors: MediaAuthor[] | null;
    Badge: string;
    TopicalTags?: TopicalTags[];
    IsRecommended: boolean;
    IsUpcomingWebinar: boolean;
    IsLiveWebinar: boolean;
    OpenInNewTab: boolean;
    ShowSvgIcons: boolean;
    ExternalLinks: PodcastLinks;
    PlayerLink: string; 
}

export interface InsightsFacetTerms {
    RelatedMediaTypes: { [key: string]: number };
    Categories: { [key: string]: number };
}

export interface BaseMediaGrid {
    Total: number;
    PageNumber: number;
    PageSize: number;
    HasMoreItems: boolean;
    PageTotalCount: number;
}

export interface RelatedMediaGrid extends BaseMediaGrid {
    GridCardDetails: MediaPreview[];
    FacetTerms: InsightsFacetTerms;
    MediaTypes: { [key: string]: boolean };
}

export interface RelatedMediaGridViewModel {
    Result: RelatedMediaGrid;
    Success: boolean;
}

export interface RelatedMediaItem {
    id: number;
    element: Element;
    blockID: number;
    isContentAreaDriven: boolean;
    category: string;
    categoryID: string;
    topicalTags: string;
    contentTypeTags: string;
    locationTags: string;
    fundTags: string;
    count: number;
    insightsType: string;
    author: string;
    authorID: string;
    template: string;
    siteContext: string;
    lang: string;
    hasBothCategoryAndMediaType: boolean;
    nextPage: number;
    currentPage: number;
    isPaginationEnabled: boolean;
    linkFormat: string;
}

export interface VERelatedMedia {
    initialised: boolean;
    relatedMediaItems: RelatedMediaItem[];
    endpoint: string;
    debug: boolean;
    shouldScrollIntoView: boolean;
    getData: (relatedMediaItem: RelatedMediaItem, pageOverride?: string, skipUrlUpdate?: boolean) => Promise<void>;
    clearData: (relatedMediaItem: RelatedMediaItem) => void;
    handlePagination: (relatedMediaItem: RelatedMediaItem, data: RelatedMediaGridViewModel, skipUrlUpdate?: boolean) => void;
    updateDropdownStatus: (result: RelatedMediaGrid, relatedMediaItem: RelatedMediaItem) => void;
    updatePaginationUrl: (pageNumber: number, categoryId: string, mediaType: string, gridId: number) => void;
    configureGridByQueryStrings: Function,
    scrollIntoView: (overrideElement?: HTMLElement) => void,
    init: Function
}

export interface ShareConfig {
    tooltipText: string;
    successText: string;
    duration: number;
}

export const DEFAULT_CONFIG: ShareConfig = {
    tooltipText: 'Share',
    successText: 'Link Copied to Clipboard',
    duration: 2000
};

export interface PodcastLinks {
    YouTube: string | null;
    Apple: string | null;
    Spotify: string | null;
    SoundCloud: string | null;
}

export interface PodcastConfig {
    links: PodcastLinks;
}